var tab_len = document.getElementsByClassName('tab-radio').length;
if (tab_len) {
  var element = document.getElementById('product-tabs');
  element.classList.add('tabs-' + tab_len);
}

document.addEventListener('DOMContentLoaded', function () {
  // Accordion functionality
  const accItems = document.querySelectorAll('.acc-single');
const accHeadings = document.querySelectorAll('.accordionItemHeading');

accHeadings.forEach((heading) => {
  heading.addEventListener('click', toggleItem, false);
});

function toggleItem() {
  const parentItem = this.parentNode;
  const isAlreadyOpen = parentItem.classList.contains('open');

  // Close all first
  accItems.forEach((item) => {
    item.classList.add('close');
    item.classList.remove('open');
  });

  // If it wasn't already open, open it now
  if (!isAlreadyOpen) {
    parentItem.classList.add('open');
    parentItem.classList.remove('close');
  }
}


  // Footer accordion functionality
  const footerAccItems = document.querySelectorAll('.accordionItem');
  const footerAccHeadings = document.querySelectorAll('.accordionHeading');

  footerAccHeadings.forEach((heading) => {
    heading.addEventListener('click', toggleFooterItem, false);
  });

  function toggleFooterItem() {
    footerAccItems.forEach((item) => {
      item.classList.add('close');
      item.classList.remove('open');
    });

    if (this.parentNode.classList.contains('close')) {
      this.parentNode.classList.add('open');
      this.parentNode.classList.remove('close');
    }
  }

  // Product template specific functionality
  const body = document.querySelector('body');
  if (body.classList.contains('template-product')) {
    const otherElement = document.getElementById('starRating');
    const radioInput = document.getElementById('input-tab-2');
    const reviewTab = document.getElementById('review-tab');

    if (window.innerWidth < 768) {
      const elementTab = document.getElementById('product-tabs');
      if (elementTab) {
        elementTab.remove();
      }
    }

    if (otherElement) {
      otherElement.addEventListener('click', function () {
        if (radioInput) {
          radioInput.checked = true;
        }
        reviewTab.click();
        const productTabs = document.getElementById('product--tabs');
        if (productTabs) {
          window.scrollTo({
            top: productTabs.offsetTop,
            behavior: 'smooth',
          });
        }
      });
    }
  }

  // Calculate height of header group sections
  const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');

  const updateHeaderHeight = () => {
    let totalHeight = 0;
    headerGroupSections.forEach((section) => {
      totalHeight += section.offsetHeight;
    });

    document.documentElement.style.setProperty('--header-sections-height', `${totalHeight}px`);
  };

  const mediaQuery = window.matchMedia('(min-width: 768px)');
  mediaQuery.addEventListener('change', updateHeaderHeight);

  // Initial calculation
  updateHeaderHeight();

  // Recalculate on window resize
  window.addEventListener('resize', updateHeaderHeight);
});
